/*
|--------------------------------------------------------------------------
| Contextly
|--------------------------------------------------------------------------
*/

/**
 * Contextly
 * @namespace
 */
__gh__webApp.consumerMarketing.contextly = {
		
		
	/**
	 * Check to see if Contextly is disabled
	 */
	 "isDisabled": function(){
		var commonJS = __gh__webApp.common;
		return (commonJS.isObjectPropertySet(__gh__coreData["3rdPartyData"],"consumerMarketing.contextly.id") && __gh__coreData["3rdPartyData"].consumerMarketing.contextly.id) ? false : true;
	},
	
	
	/**
	 * Load Article Widgets
	 * @namespce
	 * @param {string} articleDOM - article dom (id or class)
	 * @param {object} articleObject - article json object
	 */
	"loadArticleWidgets": function(articleDOM,articleObject){
		var thisObject = __gh__webApp.consumerMarketing.contextly;
		
		if (thisObject.isDisabled()) {
			thisObject.removeWidgetDOMS(articleDOM);
			return;
		}
		
		var mainImageLink = ("link" in articleObject.image) ? articleObject.image.link : null;
		

		Contextly.ready('widgets',{
			context: articleDOM,
			metadata: {
				title				: articleObject.title,
				type				: articleObject.type,
				pub_date			: articleObject.pubDateFormat["yyyy-mm-dd hh:mm:ss"],
				url					: articleObject.link,
				mod_date			: articleObject.modDateFormat["yyyy-mm-dd hh:mm:ss"],
				post_id				: articleObject.id,
				author_id			: articleObject.bylineFormat.commaDelimited,
				author_name 		: articleObject.bylineFormat.commaDelimited,
				tags				: articleObject.taxonomies,
				categories			: [articleObject.category],
				image 				: mainImageLink
			}
		});
					
	},
	
	
	/**
	 * Remove widget doms from the page
	 * @namespce
	 * @param {string} articleDOM - article dom (id or class)
	 */
	"removeWidgetDOMS": function(articleDOM){
		$(articleDOM).find(".ctx-subscribe-container").remove();
	},
};
